import { render, staticRenderFns } from "./fishing-result.vue?vue&type=template&id=421357d2&scoped=true"
import script from "./fishing-result.vue?vue&type=script&lang=js"
export * from "./fishing-result.vue?vue&type=script&lang=js"
import style0 from "./fishing-result.vue?vue&type=style&index=0&id=421357d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421357d2",
  null
  
)

export default component.exports